import React from 'react';
import bemify from 'bemify-js';

import { PathIcon } from '@zapier/editor';

import Icon from 'app/common/components/Icon';

const bem = bemify('choice-row');

const PathHeaderChoice = ({ choice }) => {
  return (
    <div className={bem()} style={{ backgroundColor: choice.lightPathColor }}>
      {choice.isNestedPath && (
        <span className={bem('__nest-arrow')}>
          <Icon size={20} type="arrow-right-2" />
        </span>
      )}
      <span className={bem('__emoji-wrapper')}>
        <PathIcon color={choice.color} emoji={choice.emoji} size="large" />
      </span>
      <span className="choice-name">{choice.label}</span>
    </div>
  );
};

export default PathHeaderChoice;
